
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/federations-directory",
      function () {
        return require("private-next-pages/federations-directory.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/federations-directory"])
      });
    }
  